export const ActivityOriginType = {
  IMPORTED: 'Imported',
  TRACKED: 'Tracked',
};

export const EmailStateType = {
  READ: 'Read',
  NONE: 'None',
};

export const ActivityType = {
  COMMON_UPDATE: 'CommonUpdate',
  CONTACT_ACTIVITY: 'ContactActivity',
  EMAIL: 'Email',
  CALL: 'Call',
  PIPELINE_WORKFLOW: 'PipelineWorkflow',
  CUSTOM_EVENT: 'CustomEvent',
};

export const EMAILS_INCLUDE_CONFIG = ['attachmentdescription', 'linkedresourcedescription'];
